export default __webpack_public_path__ + "static/media/inscription.9a4b57d1.png";